<template>
    <div class="col-md-12">   
        <KTCard v-bind:title="page_title">
            <template v-slot:body>
                <div class="d-flex flex-column flex-root">
                    <div
                        class="error error-6 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
                        
                    >
                        <!-- begin:: Content -->
                        <div class="d-flex flex-column flex-row-fluid text-center justify-content-center align-items-center">
                            <h1
                                class="error-title font-weight-boldest mb-12"
                            >
                                Üzgünüz...
                            </h1>
                            <p class="display-4 font-weight-bold">
                                Borcunuz olduğundan dolayı herhangi bir işlem yapamazsınız. 
                                <br />Lütfen aşağıdaki butona tıklayarak ödeme sayfasına gidiniz.
                            </p>
                            <p>
                                <b-button
                                    size="lg"
                                    variant="success"
                                    @click="goToMembershipPage"
                                >
                                <i class="la la-money"></i>
                                    Ödeme Sayfasına Git
                                </b-button>
                            </p>
                        </div>
                        <!-- end:: Content -->
                    </div>
                </div>
            </template>
        </KTCard>
    </div>
</template>


<script>
import KTCard from "@/view/content/Card.vue";
export default {
    name: "credit-balance",
    data() {
        return {
            page_title: 'Borcunuz Bulunmaktadır...',
        };
    },
   
    mounted() {},
    methods: {
        goToMembershipPage() {
            this.$router.push({name: 'my-membership'});
        },
    },
    components: {
        KTCard,
        //Multiselect
    },

};
</script>
